import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import ServiceDetail from "@/pages/ServiceDetail";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Portfolio from "@/pages/Portfolio";
import GetStarted from "@/pages/GetStarted";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import NotFound from "@/pages/NotFound";
import { Toaster } from "@/components/ui/sonner";

// Admin
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/admin/ProtectedRoute";
import AdminLayout from "@/components/admin/AdminLayout";
import AdminLogin from "@/pages/admin/Login";
import ResetPassword from "@/pages/admin/ResetPassword";
import AdminDashboard from "@/pages/admin/Dashboard";
import AdminLeads from "@/pages/admin/Leads";
import AdminContacts from "@/pages/admin/Contacts";
import AdminTemplates from "@/pages/admin/Templates";
import TemplateEditor from "@/pages/admin/TemplateEditor";
import AdminCampaigns from "@/pages/admin/Campaigns";
import CampaignComposer from "@/pages/admin/CampaignComposer";
import CampaignDetail from "@/pages/admin/CampaignDetail";
import AdminActivity from "@/pages/admin/Activity";
import LeadFinder from "@/pages/admin/LeadFinder";
import SystemHealth from "@/pages/admin/SystemHealth";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";

function PublicSite() {
    return (
        <Layout>
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/services" element={<Services />} />
                <Route path="/services/:slug" element={<ServiceDetail />} />
                <Route path="/about" element={<About />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/portfolio" element={<Portfolio />} />
                <Route path="/get-started" element={<GetStarted />} />
                <Route path="/blog" element={<Blog />} />
                <Route path="/blog/:slug" element={<BlogPost />} />
                <Route path="/privacy" element={<Privacy />} />
                <Route path="/terms" element={<Terms />} />
                <Route path="*" element={<NotFound />} />
            </Routes>
        </Layout>
    );
}

function AdminArea() {
    return (
        <ProtectedRoute>
            <AdminLayout>
                <Routes>
                    <Route index element={<AdminDashboard />} />
                    <Route path="leads" element={<AdminLeads />} />
                    <Route path="contacts" element={<AdminContacts />} />
                    <Route path="templates" element={<AdminTemplates />} />
                    <Route path="templates/new" element={<TemplateEditor />} />
                    <Route path="templates/:id" element={<TemplateEditor />} />
                    <Route path="campaigns" element={<AdminCampaigns />} />
                    <Route path="campaigns/new" element={<CampaignComposer />} />
                    <Route path="campaigns/:id" element={<CampaignDetail />} />
                    <Route path="campaigns/:id/edit" element={<CampaignComposer />} />
                    <Route path="activity" element={<AdminActivity />} />
                    <Route path="lead-finder" element={<LeadFinder />} />
                    <Route path="system-health" element={<SystemHealth />} />
                </Routes>
            </AdminLayout>
        </ProtectedRoute>
    );
}

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <AuthProvider>
                    <Routes>
                        <Route path="/admin/login" element={<AdminLogin />} />
                        <Route path="/admin/reset-password" element={<ResetPassword />} />
                        <Route path="/admin/*" element={<AdminArea />} />
                        <Route path="/*" element={<PublicSite />} />
                    </Routes>
                </AuthProvider>
            </BrowserRouter>
            <Toaster position="top-right" theme="dark" />
        </div>
    );
}

export default App;
